import React, { Component } from "react";
import {
  Wrapper,
  CardBody,
  WistiaVideo,
  Title,
  Card,
  Copy,
  Row
} from "app/NativeComponents/common";
import SkipButton from "./SkipButton";

import { loadDashboardStep } from "app/NativeActions";

class ContactLeadsStep extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      dashboard_step: null
    };

    this.completedStep = this.completedStep.bind(this);
  }

  componentDidMount() {
    loadDashboardStep("contact_leads")
      .then(data => {
        if (data && data.items) {
          if (data.items.length > 0) {
            this.setState({
              dashboard_step: data.items[0]
                ? data.items[0].fields
                  ? data.items[0].fields
                  : null
                : null,
              loading: false
            });
          }
        }
        this.setState(() => ({ loading: false }));
      })
      .catch(err => {
        this.setState(() => ({ loading: false }));
      });
  }

  renderVideo1(dashboard_step) {
    if (dashboard_step.video1WistiaUrl) {
      return (
        <Wrapper style={{ alignItems: "center", justifyContent: "center" }}>
          <Card style={{ alignSelf: "center", overflow: "hidden" }}>
            <WistiaVideo
              wistia_url={dashboard_step.video1WistiaUrl}
              wistia_id={dashboard_step.video1WistiaId}
              height={!this.props.dashboardMobile ? 180 : 90}
              width={!this.props.dashboardMobile ? 320 : 160}
            />
          </Card>
        </Wrapper>
      );
    }
  }
  renderVideo2(dashboard_step) {
    if (dashboard_step.video2WistiaUrl) {
      return (
        <Wrapper style={{ alignItems: "center", justifyContent: "center" }}>
          <Card style={{ alignSelf: "center", overflow: "hidden" }}>
            <WistiaVideo
              wistia_url={dashboard_step.video2WistiaUrl}
              wistia_id={dashboard_step.video2WistiaId}
              height={!this.props.dashboardMobile ? 180 : 90}
              width={!this.props.dashboardMobile ? 320 : 160}
            />
          </Card>
        </Wrapper>
      );
    }
  }
  completedStep() {
    this.props.updateTab(
      this.props.is_enterprise ? "work_with_us" : "find_a_mentor"
    );
    this.props.updateDashboard({
      token: this.props.token,
      type: this.props.is_enterprise ? "enterprise_step" : "dashboard_step",
      current_step: this.props.is_enterprise ? "work_with_us" : "find_a_mentor"
    });
  }
  render() {
    const { loading, dashboard_step } = this.state;
    if (this.props.active_tab == "contact_leads") {
      if (!loading && dashboard_step) {
        return (
          <Wrapper>
            <CardBody>
              <Row
                style={{
                  alignItems: "center",
                  justifyContent: "center",
                  flexDirection: this.props.dashboardMobile ? "column" : "row"
                }}
              >
                <Wrapper style={{ padding: 20 }}>
                  <Wrapper
                    style={{
                      alignItems: "center",
                      justifyContent: "center",
                      flexDirection: this.props.dashboardMobile
                        ? "row"
                        : "column"
                    }}
                  >
                    {this.renderVideo1(dashboard_step)}
                    {this.renderVideo2(dashboard_step)}
                  </Wrapper>
                </Wrapper>
                <Wrapper
                  style={{
                    padding: 20,
                    paddingLeft: this.props.dashboardMobile ? 0 : 20,
                    paddingTop: this.props.dashboardMobile ? 20 : 0
                  }}
                >
                  <Title style={{ textAlign: "center", marginBottom: 10 }}>
                    {dashboard_step.header}
                  </Title>
                  <Copy style={{ textAlign: "center" }}>
                    {dashboard_step.description}
                  </Copy>
                  <SkipButton
                    //completed_step={this.state.completed_step}
                    onPress={this.completedStep}
                    title={dashboard_step.nextButtonText}
                  />
                </Wrapper>
              </Row>
            </CardBody>
          </Wrapper>
        );
      }
    }
    return <Wrapper />;
  }
}

export default ContactLeadsStep;
